import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Firebase from './firebase'
import VueMask from 'v-mask'
import axios from 'axios'
import moment from 'moment'
import firebase from 'firebase/app'
import './assets/scss/app.scss'
import 'popper.js'
import 'bootstrap'
import 'floating-vue/dist/style.css'
import Toast from 'vue-toastification'
import VueScrollTo from 'vue-scrollto'
import VCalendar from 'v-calendar'
import VueCryptojs from 'vue-cryptojs'
import VueCookie from 'vue-cookie'
import "vue-toastification/dist/index.css";
import pagarme from 'pagarme/browser'
import VueApexCharts from 'vue-apexcharts'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
import FloatingVue from 'floating-vue'
import './plugins/displayBRL.js'
import "./utils/directives";
import { setCurrentProfileFromAffiliate, clearCurrentProfile } from './utils/currentProfile'
import { firebaseApp } from './firebase'


Vue.use(Toast, {
  // icon: {
  //   iconClass: 'fas fa-dollar-sign'
  // },
  transition: 'Vue-Toastification__fade',
  containerClassName: 'my-toast',
  maxToasts: 1,
  position: 'bottom-center',
  timeout: 5000,
  newestOnTop: true,
  draggable: false,
  closeButton: false,
  pauseOnFocusLoss: false,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  pauseOnHover: false,
  closeOnClick: false,
  toastClassName: 'my-custom-toast-class',
  bodyClassName: ['custom-class-1', 'custom-class-2']
})

let app
Vue.use(FloatingVue)
Vue.use(LottieAnimation); // add lottie-animation to your global scope
Vue.use(VueApexCharts)
Vue.use(VueCryptojs)
Vue.use(VueScrollTo)
Vue.use(Firebase)
Vue.use(VueMask)
Vue.use(VueScrollTo)
Vue.use(VCalendar)
Vue.use(VueCookie)
Vue.prototype.$pagarme = pagarme
Vue.prototype.$http = axios
Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.component('apexchart', VueApexCharts)

firebase.apps[0].auth().onAuthStateChanged(async user => {
  document.title = 'HUBSTROM'
  window.uid = user ? user.uid : null

  try {
    if (user) {
      await setCurrentProfileFromAffiliate(firebaseApp, Vue.cookie, user.uid)
    } else {
      clearCurrentProfile(Vue.cookie)
    }
  } catch (error) {
    console.error('Erro ao sincronizar currentProfile:', error)
  }

  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})
